"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormRadioGroup = void 0;
const form_field_1 = require("./form-field");
const radio_group_1 = require("../../../components/radio-group/radio-group");
exports.FormRadioGroup = form_field_1.formFieldFactory(radio_group_1.RadioGroup);
//# sourceMappingURL=form-radio-group.js.map